/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_TitleInputs */



/**
* | output |
* | --- |
* | "Translation Merge" |
*
* @param {Translation_Merge_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_title = /** @type {((inputs?: Translation_Merge_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusion de traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungszusammenführung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unione di traduzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слияние переводов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusión de traducciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译合并")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳マージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद विलय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fusão de traduções")
	return /** @type {LocalizedString} */ ("Translation Merge")
});